const PROJECT_ID = "yrbozaa68v";
let scheduled = false;
let loadPromise = null;

function loadClarity() {
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve) => {
    if (document.querySelector(`script[data-clarity-project="${PROJECT_ID}"]`)) {
      resolve();
      return;
    }
    window.clarity = window.clarity || ((...args) => {
      window.clarity.q = window.clarity.q || [];
      window.clarity.q.push(args);
    });
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
    script.dataset.clarityProject = PROJECT_ID;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });
  return loadPromise;
}

export function scheduleClarity() {
  if (scheduled || typeof window === "undefined") return;
  scheduled = true;
  const start = () => { void loadClarity(); };
  const waitForFirstPaint = () => {
    if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 2500 });
    else window.setTimeout(start, 1000);
  };
  window.setTimeout(waitForFirstPaint, 1500);
}